<app-onboarding-header [showHeader]="(isOnboarding && !isOnboardingComplete) || isOnboarding"></app-onboarding-header>
<div style="/*max-width: 1520px;*/min-width: 300px; /*margin: 0 auto;*/">
    
    <div id="hiddenUserLoaderContentJSLibrary" style="display: none;">
        <!-- This is Marketing form for JS Library -->
        <div [attr.data-form-block-id]="settings?.crmFormPageIdJsLibrary" ></div>
    
        <!-- This is section for general Marketing tracking configuration settings -->
        <div [attr.id]="settings?.aliceCrmFormConfigurationDivId" ></div>
        <div class="d365-mkt-config" style="display:none" [attr.data-website-id]="settings?.aliceCrmDataWebsiteId" [attr.data-hostname]="settings?.aliceCrmDataHostName" data-msdyn-tracking="false">
        </div>
        <!-- End of general Marketing tracking configuration settings -->
    </div>    
    <div *ngIf="loadSubmitForm" style="display: none;" [attr.data-form-block-id]="settings?.aliceCrmDataFormBlockId"></div> 

    <svg-icon class="sxh-hidden" src="assets/icons/dist/sx-icon-sprite.svg"></svg-icon>

    <app-cookie-consent [approved]="consentApproved" [hidden]="(isPermissionLoading$|async)"></app-cookie-consent>

    <!-- Topp navbar: Show if NOT handset -->
    <div class="body" *ngIf="!(isHandset$ | async)">
        <div class="sx-navbar fixed-top navbar-light" *ngIf="displayPageChrome">
            <div class="sx-navbar__header-wrapper">
                <header class="sx-topheader" app-header (toggleEvent)="onToggleMenu($event)" 
                    [isHandset]="isHandset$ | async"
                    [isLoggedIn]="isLoggedInAndPermissionsLoaded$|async" 
                    [unreadNotificationCount]="unreadNotificationCount$|async"
                    [unreadMessagesCount]="unreadMessagesCount$|async" 
                    [userInfo]="userInfo$|async" 
                    [unreadNotifications$]="unreadNotifications$"
                    [bannerMessages]="bannerMessages$|async"
                    [userType]="userType$|async" 
                    [isEnableAppLauncher]="isEnableAppLauncher"
                    [meteringPoints]="meteringPoints$|async"
                    [unreadTipsCount]="unreadTipsCount$|async"
                    *ngIf="displayPageChrome">
                </header>
            </div>
        </div>
    </div>

    <mat-sidenav-container class="sidenav-container">
        <mat-sidenav #drawer class="sx-sidenav" fixedInViewport="true" 
                [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
                [mode]="(isHandset$ | async) ? 'push' : 'side'" 
                [position]="(isHandset$ | async) ? 'end' : 'start'"
                [opened]="!(isHandset$ | async)"
                *ngIf="displayPageChrome && (isLoggedInAndPermissionsLoaded$|async) && (isMenuItemsLoaded$|async) === true">
                
                <div *ngIf="isHandset$ | async">
                    <app-nav-buttons *ngIf="isLoggedInAndPermissionsLoaded$|async" 
                        [isHandset]="isHandset$ | async"
                        [isLoggedIn]="isLoggedInAndPermissionsLoaded$|async" 
                        [unreadNotificationCount]="unreadNotificationCount$|async" 
                        [unreadNotifications]="unreadNotifications$|async" 
                        [unreadMessagesCount]="unreadMessagesCount$|async"
                        [bannerMessages]="bannerMessages$|async"
                        [userInfo]="userInfo$|async"
                        [unreadTipsCount]="unreadTipsCount$|async"
                        [meteringPoints]="meteringPoints$|async">
                    </app-nav-buttons>
                </div>
                
                <app-multi-level-menu *ngIf="showMultiLevelMenu" 
                    [isWhiteLabel]="isWhiteLabel" 
                    [isHandset]="isHandset$ | async" 
                    [meteringPoints]="meteringPoints$|async" 
                    [menuItems]="menuItems" 
                    (toggleEvent)="closeMenu()">
                </app-multi-level-menu>
                <mat-nav-list *ngIf="!showMultiLevelMenu">
                    <app-sidebar [isHandset]="isHandset$ | async" [meteringPoints]="meteringPoints$|async" (toggleEvent)="closeMenu()"></app-sidebar>
                </mat-nav-list>
        </mat-sidenav>

        <mat-sidenav-content [className]="displayPageChrome ? 'app-body':'app-body full-screen'">
            <!-- Show if handset -->
            <div *ngIf="(isHandset$ | async)">
                <header class="sx-topheader" app-header (toggleEvent)="onToggleMenu($event)" 
                    [isHandset]="isHandset$ | async"
                    [isLoggedIn]="isLoggedInAndPermissionsLoaded$|async" 
                    [unreadNotificationCount]="unreadNotificationCount$|async"
                    [unreadMessagesCount]="unreadMessagesCount$|async" 
                    [userInfo]="userInfo$|async" 
                    [unreadNotifications]="unreadNotifications$|async"
                    [bannerMessages]="bannerMessages$|async"
                    [userType]="userType$|async"
                    [isEnableAppLauncher]="isEnableAppLauncher"
                    [meteringPoints]="meteringPoints$|async"
                    [unreadTipsCount]="unreadTipsCount$|async"
                    *ngIf="displayPageChrome">
                </header>
            </div>
            
            <div class="app-body__main" >
                <main app-content>
                    <app-registration-pane *ngIf="(isLoggedInAndPermissionsLoaded$|async) && !isOnboarding"></app-registration-pane>
                    <app-system-message-pane *ngIf="!isOnboarding"
                        [isLoggedIn]="isLoggedInAndPermissionsLoaded$|async">
                    </app-system-message-pane>
                    <div [class.app-body__main-onboarding]="isOnboarding">
                        <router-outlet (activate)="onActivate($event)"></router-outlet>
                    </div>
                </main>
               
                <footer class="sx-footer" >
                    <!-- <div class="sx-footer__in-row-icons">
                        <img class="sx-footer__logo" src="/assets/icons/stockholm-exergi-logo.svg" />
                        <div class="sx-footer__in-socialmedia">
                                <a class="sx-footer__in-icon" target="_blank" href="https://twitter.com/SthlmExergi">
                                    <svg>
                                        <use xlink:href="#in-twitter" href="#in-twitter" />
                                    </svg>
                                </a>
                                <a class="sx-footer__in-icon" target="_blank" href="https://www.youtube.com/channel/UCGd9A2kKWSDgZqTpAgWtIJQ">
                                    <svg>
                                        <use xlink:href="#in-youtube" href="#in-youtube" />
                                    </svg>
                                </a>
                                <a class="sx-footer__in-icon" target="_blank" href="https://www.facebook.com/stockholmexergi/">
                                    <svg>
                                        <use xlink:href="#in-facebook" href="#in-facebook" />
                                    </svg>
                                </a>
                                <a class="sx-footer__in-icon" target="_blank" href="https://www.linkedin.com/company/stockholm-exergi/">
                                    <svg>
                                        <use xlink:href="#in-linkedin" href="#in-linkedin" />
                                    </svg>
                                </a>
                                <a class="sx-footer__in-icon nomargin" target="_blank" href="https://www.instagram.com/stockholmexergi/">
                                    <svg>
                                        <use xlink:href="#in-instagram" href="#in-instagram" />
                                    </svg>
                                </a>
                        </div>
                    </div> -->
                     <div class="sx-footer__in-row-icons">
                        <img class="sx-footer__logo"  src="/assets/icons/stockholm-exergi-logo.svg" />
                        <div class="sx-footer__in-socialmedia">

                            <a  target="_blank" href="https://x.com/SthlmExergi" class="social-icon" >
                                <svg>
                                    <use xlink:href="#twitter-river" href="#twitter-river" />
                                </svg>
                            </a>
                            <a  target="_blank" href="https://www.linkedin.com/company/stockholm-exergi/" class="social-icon" >
                                <svg>
                                    <use xlink:href="#linkedin-river" href="#linkedin-river" />
                                </svg>
                            </a>
                            <a  target="_blank" href="https://www.instagram.com/stockholmexergi/" class="social-icon">
                                <svg>
                                    <use xlink:href="#instagram-river" href="#instagram-river" />
                                </svg>
                            </a>
                            <a  target="_blank" href="https://www.facebook.com/stockholmexergi" class="social-icon" >
                                <svg>
                                    <use xlink:href="#fb-river" href="#fb-river" />
                                </svg>
                            </a>
                            <a  target="_blank" href="https://www.youtube.com/channel/UCGd9A2kKWSDgZqTpAgWtIJQ" class="social-icon" >
                                <svg>
                                    <use xlink:href="#youtube-river" href="#youtube-river" />
                                </svg>
                            </a>
                        </div>
                     </div>
                  
                    <div class="sx-footer__in-row sx-footer__in-text">
                        <div>
                            <p class="sx-footer__ingress">{{'main.footer.ingress' | translate}}</p>
                        </div>
                        <div>
                            <p class="sx-footer__ingress sx-footer__ingress--right">© Stockholm Exergi AB <br>Org.nr: 556016-9095</p>
                        </div>
                    </div>
                </footer>
            </div>
           
        <app-help class="app-body__help" *ngIf="displayPageChrome && (currentHelpState$|async) !== inActiveHelp"></app-help>
        <app-tips class="sx-tips-container" [tips]="(tips$ | async)" *ngIf="(isShowTips$|async)"></app-tips>
        </mat-sidenav-content>

    </mat-sidenav-container>
</div>
